import React from "react";

/**
 * @function Loader
 * @desc This function returns the loader structure
 */
export const Loader = props => {
  return (
    <div
      className="loader-wrap"
      className={
        props.className ? `loader-wrap ${props.className}` : "loader-wrap"
      }
    >
      <img
        className="loading-image"
        src={require("../images/loader.svg")}
        alt="Loading..."
      />
    </div>
  );
};
